import "@/print.css";
import { BSM_LOGO_PRINT_PNG } from "./logoData";

const esc = (s) => String(s || "").slice(0, 90).replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/[^\x20-\x7e]/g, (c) => "\\" + c.codePointAt(0).toString(16) + " ");

export function PrintPageStyle({ title, date, rtl = false, pageWord = "Side", ofWord = "af", footer = null }) {
  const left = `content: "BSM A/S"; font: 700 8pt Manrope, sans-serif; letter-spacing: 0.14em; color: #A83232;`;
  const right = `content: "${esc(title)}${date ? ` · ${esc(date)}` : ""}"; font: 500 8pt Manrope, sans-serif; color: #A83232;`;
  const css = `@media print { @page {
    @top-left { ${rtl ? right : left} vertical-align: bottom; padding-bottom: 5mm; }
    @top-center { content: none; }
    @top-right { ${rtl ? left : right} vertical-align: bottom; padding-bottom: 5mm; }
    @bottom-left { ${footer ? `content: "${esc(footer)}"; font: 500 7.5pt Manrope, sans-serif; color: #A8A29E; vertical-align: top; padding-top: 5mm;` : "content: none;"} }
    @bottom-center { content: url("${BSM_LOGO_PRINT_PNG}"); vertical-align: top; padding-top: 4mm; }
    @bottom-right { content: "${esc(pageWord)} " counter(page) " ${esc(ofWord)} " counter(pages); font: 500 8pt Manrope, sans-serif; color: #A8A29E; vertical-align: top; padding-top: 5mm; }
  } }`;
  return <><style>{css}</style><img src={BSM_LOGO_PRINT_PNG} alt="" aria-hidden="true" style={{ position: "fixed", width: 1, height: 1, opacity: 0, pointerEvents: "none" }} /></>;
}
